var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCupra({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.176,
    height: 20.118,
    viewBox: "0 0 26.176 20.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path8-4",
    d: "M1103.111,963.354l-4.247,2.078h0l2.589.993a2.122,2.122,0,0,1,1.4,1.1,1.961,1.961,0,0,1-.424,1.713l-1.419,2.213q-2.517,3.94-5.036,7.871v-2.433h0q.966-3.041,1.877-6.081.258-.868.511-1.735a.52.52,0,0,0-.3-.724l-2.583-1.271-2.572,1.269a.518.518,0,0,0-.3.724q.252.87.511,1.735.909,3.053,1.877,6.081h0v2.433q-2.523-3.934-5.035-7.871l-1.419-2.213a1.921,1.921,0,0,1-.424-1.713,2.09,2.09,0,0,1,1.4-1.1l2.589-.993h0l-4.247-2.078h0l1.324,2.22-2.189.842q-2.3-3.6-4.6-7.213c4.359,1.545,8.717,3.1,13.088,4.6,4.376-1.494,8.729-3.051,13.088-4.6q-2.291,3.606-4.593,7.2l-2.189-.842,1.324-2.22",
    transform: "translate(-1082.4 -959.2)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupra);
export default __webpack_public_path__ + "static/media/cupra.d6836165da6c64c3e993a9c3466b37eb.svg";
export { ForwardRef as ReactComponent };